export { default } from "./StudentPreview";